<template>
  <div
    ref="trigger"
    class="tooltip-container"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <i class="fas fa-info-circle info-icon"></i>
    <div v-if="tooltipVisible" class="tooltip-box" :style="tooltipStyle">{{ content }}</div>
  </div>
</template>

<script>
export default {
  name: 'IconWithTooltip',
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tooltipVisible: false,
      tooltipStyle: {},
    };
  },
  methods: {
    showTooltip() {
      this.tooltipVisible = true;
      this.$nextTick(this.positionTooltip);
    },
    hideTooltip() {
      this.tooltipVisible = false;
      this.tooltipStyle = {};
    },
    positionTooltip() {
      const trigger = this.$refs.trigger;
      if (!trigger) return;

      const rect = trigger.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const tooltipWidth = Math.min(320, Math.max(180, viewportWidth - 24));
      const halfWidth = tooltipWidth / 2;
      const center = rect.left + rect.width / 2;
      const left = Math.min(
        Math.max(center, 12 + halfWidth),
        viewportWidth - 12 - halfWidth
      );

      this.tooltipStyle = {
        left: `${left}px`,
        top: `${rect.bottom + 8}px`,
        width: `${tooltipWidth}px`,
      };
    },
  },
};
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-inline: 0.5rem;
  line-height: 1;
}

.info-icon {
  color: #007bff; /* Info icon color */
  font-size: 1rem; /* Adjust size as needed */
  display: block;
  margin: auto;
}

.tooltip-box {
  position: fixed;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  text-align: left; /* Align text to the left */
  padding: 8px 12px;
  border-radius: 5px;
  white-space: normal; /* Allow text to wrap */
  z-index: 3000;
  opacity: 0.9;
  font-size: 0.875rem;
  max-width: calc(100vw - 24px);
  pointer-events: none;
  word-wrap: break-word; /* Break words if they are too long */
  line-height: 1.45;
}

.tooltip-box::after {
  content: '';
  position: absolute;
  bottom: 100%; /* Arrow pointing up */
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #333 transparent; /* Triangle for tooltip arrow */
}
</style>
